export default __webpack_public_path__ + "static/slide3-6943dc55bb037ba25d43a76682c21240.png";